import { render, staticRenderFns } from "./CustomersTimeSlotsStatistics.vue?vue&type=template&id=01994aa2"
import script from "./CustomersTimeSlotsStatistics.vue?vue&type=script&lang=ts"
export * from "./CustomersTimeSlotsStatistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports